export default __webpack_public_path__ + "static/media/fpb40030.d3671858.png";